module.exports = __webpack_public_path__ + "img/asset.472532e6.png";